import React from "react";
import { useLang } from "../../context/LanguageContext";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { buildWaLink, IMAGES } from "../../lib/constants";
import { BedDouble, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const Rooms = () => {
  const { t, lang } = useLang();

  const imgs = [IMAGES.room1, IMAGES.room2, IMAGES.room3];

  return (
    <section
      id="rooms"
      data-testid="rooms-section"
      className="relative py-24 md:py-40 bg-white border-y border-stone-100"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-20">
          <div>
            <Reveal>
              <span className="text-xs uppercase tracking-[0.35em] text-amber-800/80">
                — {t.rooms.overline}
              </span>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="mt-6 font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-stone-900 max-w-2xl">
                {t.rooms.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={140}>
            <p className="max-w-sm text-stone-600 font-light leading-relaxed">
              {t.rooms.description}
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          {t.rooms.list.map((room, i) => (
            <Reveal key={i} delay={120 * i}>
              <article
                data-testid={`room-card-${i}`}
                className="group flex flex-col bg-white"
              >
                <div className="image-hover aspect-[4/5] bg-stone-100 overflow-hidden">
                  <img
                    src={imgs[i]}
                    alt={room.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="pt-8 flex flex-col flex-1">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <div className="text-[11px] uppercase tracking-[0.25em] text-stone-500 mb-2">
                        0{i + 1} / 0{t.rooms.list.length}
                      </div>
                      <h3 className="font-heading text-3xl md:text-4xl text-stone-900">
                        {room.name}
                      </h3>
                    </div>
                    <div className="pt-2 text-stone-400">
                      <BedDouble className="w-5 h-5" />
                    </div>
                  </div>

                  <div className="mt-3 text-sm text-amber-800/80 italic font-light">
                    {room.bed}
                  </div>

                  <p className="mt-5 text-stone-600 font-light leading-relaxed flex-1">
                    {room.desc}
                  </p>

                  <a
                    href={buildWaLink(
                      lang === "it"
                        ? `Ciao Annette Rooms, vorrei informazioni per la ${room.name}.`
                        : `Hello Annette Rooms, I'd like information for the ${room.name}.`
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`room-cta-${i}`}
                    className="mt-8 inline-flex items-center justify-between group/btn border-t border-stone-200 pt-5 text-xs uppercase tracking-[0.25em] text-stone-900 hover:text-amber-800 transition-colors"
                  >
                    <span className="flex items-center gap-2">
                      <WhatsAppIcon className="w-4 h-4" color="#25D366" />
                      {t.rooms.cta}
                    </span>
                    <ArrowUpRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
